import React from 'react';


function ItemWishlistIcon (props) {
    //console.log(props);
    if (props.on === true) {
      return (
        <div
          className="ico-torre_preferiti_on"
          onClick={(e) => props.toggle(props.id, false)}
        >
          <img src="/images/preferiti_torre.svg" alt="rimuovi dai preferiti" />
        </div>
      );
    } else {
        return (
          <div
            className="ico-torre_preferiti"
            onClick={(e) => props.toggle(props.id, true)}
          >
            <img src="/images/preferiti_torre_on.svg" alt="aggiungi ai preferiti" />
          </div>
        );
    }

}

export default ItemWishlistIcon;